const CSM_TYPE_ONLINE = 1;
const TRANSFER_JUMP_PLATFORM = 2;

/**
 * 將顯示內容解析為可跳轉的 URL
 */
export function resolveCustomerServiceUrl(body) {
  const trimmed = body?.trim();
  if (!trimmed) {
    return null;
  }
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  if (/^(t\.me|telegram\.me)\//i.test(trimmed)) {
    return `https://${trimmed}`;
  }
  if (/^www\./i.test(trimmed)) {
    return `https://${trimmed}`;
  }
  if (/^[a-z0-9.-]+\.[a-z]{2,}(\/|$)/i.test(trimmed)) {
    return `https://${trimmed}`;
  }
  return null;
}

/**
 * 依顯示內容與顯示類型跳轉頁面
 */
export function navigateCustomerServiceContent(item) {
  const body = item?.body?.trim();
  if (!body) {
    return false;
  }

  const resolvedUrl = resolveCustomerServiceUrl(body);
  const isOnline = Number(item.serviceType ?? item.type) === CSM_TYPE_ONLINE;

  if (!resolvedUrl && !isOnline) {
    return false;
  }

  const target = resolvedUrl || (body.startsWith('http') ? body : `https://${body}`);
  const transferType = Number(item.onlineProviderTransferType);

  if (transferType === TRANSFER_JUMP_PLATFORM) {
    window.open(target, '_blank', 'noopener,noreferrer');
  } else {
    window.location.assign(target);
  }
  return true;
}

/**
 * 線下非 URL 內容：複製或提示
 */
export async function handleOfflineCustomerServiceContent(item, { onCopied, onFallback }) {
  const body = item?.body?.trim();
  if (!body) {
    return;
  }
  if (Number(item.copyStatus) === 1 && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(body);
      onCopied?.();
      return;
    } catch {
      // fallback below
    }
  }
  onFallback?.(body);
}
